const Admin = () => import(/* webpackChunkName: "proj" */ './Admin');
const Appl = () => import(/* webpackChunkName: "proj" */ './Appl');

export default {
  routes: [
    {
      path: '/proc/spyp/2020b2/admin',
      name: 'proc_spyp_2020b2_admin',
      component: Admin,
      meta:{public:true}
    },
    {
      path: '/proc/spyp/2020b2/appl',
      name: 'proc_spyp_2020b2_appl',
      component: Appl,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/proc/spyp/2020b2/router.js